/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes = [];

// Plan a Trip
childRoutes[childRoutes.length] = {
    path: '/trips/new',
    componentName: 'TripPlannerStartContainer',
    title: 'Plan a Trip',
    requireAuth: true,
};

// Trip Details
childRoutes[childRoutes.length] = {
    path: '/trips/:tripId',
    componentName: 'TripContentContainer',
    title: 'Trip Details',
    requireAuth: true,
};

// Plan a Trip
childRoutes[childRoutes.length] = {
    path: '/trips',
    componentName: 'RedirectToPlanner',
    title: 'Plan a Trip',
    requireAuth: false,
};

export default childRoutes;
